<template>
    <v-select hide-details outlined dense clearable :items="list" item-value="id" item-text="name" label="Draw" v-model="draw" multiple>
        <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0" small>
                <span>{{ item.name }}</span>
            </v-chip>
            <span v-if="index === 1" class="grey--text text-caption">(+{{ draw.length - 1 }})</span>
        </template>
    </v-select>
</template>

<script>
    export default {
        data(){
            return{
                list: [],
                draw: null,
            };
        },
        methods:{
            // isupdatesearch(data){
            //     this.getdata(data, true);
            // },
            // errorwatcher(data){
            //     if(data == "error"){
            //         this.formerror['field'] = 'This field is required.';
            //         this.autocomplete_search = '';
            //     }else{
            //         this.formerror = {};
            //     }
            // },
            getdata(){
                this.$axios.get( this.$_CONFIG.api('API_DRAW_DROPDOWN'))
                .then(res => {
                    this.list = res.data;
                })
                .catch(err => {
                    console.log(err)
                });
            }
        },
        computed: {
            
        },
        created(){
            
        },
        mounted() {
            this.getdata();
        }
    }
</script>
